<app-permissions-data-table [columns]="columns.value" (modifyColumns)="modifyColumns.emit()" [searchLoader]="loader" [showHeaders]="desktopView"></app-permissions-data-table>
<ng-container *ngIf="!desktopView">
    <div class="separator16"></div>
    <app-plus-button *ngIf="canAdd" (plusClicked)="addPermissionRule()"></app-plus-button>
</ng-container>
